var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-top-communication"},[_c('div',{staticClass:"icon-wrapper flex-center pointer communication-wrapper",on:{"click":_vm.goToCommunication}},[_c('i',{staticClass:"fas fa-envelope"}),(_vm.unreadMessages > 0)?_c('div',{staticClass:"communication-counter",class:{
        'more-then-9': _vm.unreadMessages > 9,
        'more-then-99': _vm.unreadMessages > 99,
      }},[(_vm.unreadMessages <= 99)?[_vm._v(" "+_vm._s(_vm.unreadMessages)+" ")]:[_vm._v(" 99+ ")]],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }